import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Dieta Especial",
  path: "/merenda/merdietaespecial",
  name: "merdietaespecial",
  component: () => import("@/views/merenda/merdietaespecial/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.DIETAESPECIALNOVO_MENU_1000600599],
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Dieta Especial",
  path: "/merenda/merdietaespecial/cadastro/:id?",
  parent: "merdietaespecial",
  name: "merdietaespecial_create",
  component: () => import("@/views/merenda/merdietaespecial/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.DIETAESPECIALNOVO_MENU_1000600599],
  },
  goesToMenu: true,
 },
];
